import { ROUTES } from "../../../api/api.routes"
import useCustomQuery, { QueryOpts } from "../../../hooks/useQuery"
import { Doc, Sorted } from "../../../types/db/collections";
import { Link } from "../../../types/db/schema/links/link.schema";

export const useFavoriteLinks = (o?: QueryOpts) => {
  const { data, isLoading, mutate } = useCustomQuery<Sorted<Doc<Link>>>(ROUTES.Links.Favorites.All, o);

  return {
    favorites: data?.items ?? [],
    favoritesById: data?.byId ?? {},
    isLoading,
    mutate
  }
}